import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';

import { API_URL, enrichedFetch } from '../../services/api';
import { AppEnum } from '../../Types/enums';
import { GlobalSearchResponse } from '../../Types/globalSearch';
import { GLOBAL_RESULTS_LIST_SIZE } from '../consts';
import { setPage } from '../reducers/globalSearchReducer';
import { RootState } from '../store';

export const getGlobalSearchResults = createAsyncThunk<
  GlobalSearchResponse,
  { pageAction?: 'increment' | 'reset' } | void,
  { state: RootState }
>('globalSearch/fetchSearchResults', async (arg, { getState, dispatch, rejectWithValue }) => {
  const { page, searchQuery, conversationsOnly, createdByMeOnly } = getState().globalSearch;
  const { selectedApp } = getState().appStatus;

  const pageAction = arg?.pageAction;

  let newPage = page;
  if (pageAction === 'increment') {
    newPage += 1;
  } else if (pageAction === 'reset') {
    newPage = 1;
  }
  const pageOffset = GLOBAL_RESULTS_LIST_SIZE * (newPage - 1);

  dispatch(setPage(newPage));

  try {
    let url = `${API_URL}/globalSearch?offset=${pageOffset}`;
    if (searchQuery.trim().length > 0) {
      url += `&q=${searchQuery}`;
    }

    if (conversationsOnly === true || conversationsOnly === false) {
      url += `&conversationsOnly=${conversationsOnly}`;
    }

    if (createdByMeOnly === true || createdByMeOnly === false) {
      url += `&createdByMeOnly=${createdByMeOnly}`;
    }

    if (selectedApp === AppEnum.DEAL_GPT) {
      url += `&foldersWithProjects=${true}`;
    }

    const response = (await enrichedFetch(url)) as GlobalSearchResponse;
    return response;
  } catch {
    enqueueSnackbar('Failed to fetch search results', { variant: 'error' });
    return rejectWithValue('Failed to fetch search results');
  }
});
